import { createFileRoute } from "@tanstack/react-router";
import MakeModelPage from "@/pages/MakeModelPage";
import { routeHead } from "@/lib/seo/route-head";
import { listingsV2QueryOptions } from "@/lib/queries/publicData";
import { countMakeModel, fuelPageCanonicalPath, fuelPageRobots } from "@/utils/makeModelFilter";

export const Route = createFileRoute("/cars/$make/$model/$fuel/")({
  head: ({ params, loaderData }) => {
    const base = routeHead("/cars/$make/$model/$fuel/", params as Record<string, string>);
    // Under 3 listings or unknown count → noindex in the server HTML; canonical stays.
    const data = loaderData as { count?: number | null; canonicalPath?: string | null } | undefined;
    const robots = fuelPageRobots(data?.count);
    let head = robots ? { ...base, meta: [...base.meta.filter((m) => m.name !== "robots"), { name: "robots", content: robots }] } : base;
    // Identical listing set to the parent model page → canonical (and og:url) point to the parent.
    if (data?.canonicalPath) {
      const href = `https://roautomarket.ro${data.canonicalPath}`;
      head = {
        ...head,
        meta: head.meta.map((m) => (m.property === "og:url" ? { ...m, content: href } : m)),
        links: head.links.map((l) => (l.rel === "canonical" ? { ...l, href } : l)),
      };
    }
    return head;
  },
  loader: async ({ context, params }) => {
    // Same query and cache key as MakeModelPage (useListingsV2).
    const make = params.make.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
    const rows = await context.queryClient
      .ensureQueryData(listingsV2QueryOptions({ country_code: "RO", make, limit: 200 }))
      .catch(() => undefined);
    if (!Array.isArray(rows)) return { count: null as number | null, canonicalPath: null as string | null };
    return { count: countMakeModel(rows as never[], params), canonicalPath: fuelPageCanonicalPath(rows as never[], params) };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <MakeModelPage />
  );
}
